import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.gray_200};
    box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
  }
`;
